import { useClerk, useAuth } from "@clerk/clerk-react";
import toast from "react-hot-toast";
import authService from "../../services/authService";

export function useImpersonation() {
  const { getToken } = useAuth();
  const clerk = useClerk();

  const impersonate = async (targetDbUserId) => {
    try {
      const jwt = await getToken();
      if (!jwt) return toast.error("Not authenticated");

      const res = await authService.impersonate(targetDbUserId);

      const actorUrl = res?.data?.data?.actorUrl;
      if (!actorUrl) return toast.error("No actorUrl returned");

      // ✅ store BEFORE signOut (redirect stops code execution)
      sessionStorage.setItem("imp_actor_url", actorUrl);
      // ✅ sign out admin session, then land on /impersonation/start
      await clerk.signOut({
        redirectUrl: `${window.location.origin}/impersonation/start`,
      });
    } catch (e) {
      console.error(e?.response?.data || e);
      toast.error(e?.response?.data?.message || "Impersonation failed");
    }
  };

  return { impersonate };
}